const HOME = '/';
const FORGOT_PASSWORD = '/user/forgot-password';
const LOGIN = '/user/login';
const REGISTER = '/user/register';
const RESET_PASSWORD = '/user/reset-password';
const ACCOUNT_ORDERS = '/account/orders';
const ACCOUNT_ORDER = '/account/order/[id]';
const ACCOUNT_WISHLIST = '/account/wishlist';
const ACCOUNT_SETTINGS = '/account/settings';
const ACCOUNT_ADDRESSES = '/account/addresses';
const SHOPPING_CART = '/cart';
const SEARCH = '/search';
const CATEGORY = '/c/[...path]';
const PRODUCT = '/p/[...path]';
const SHIPPING_RETURNS = '/help/shipping-returns';
const PRIVACY_POLICY = '/help/privacy-policy';
const TERMS_AND_CONDITIONS = '/help/terms-and-conditions';
const TERMS_OF_USE = '/help/terms-of-use';
const CONTACT_US = '/help/contact-us';
const CHECKOUT = '/checkout';
const POST_CHECKOUT_SUCCESS = '/checkout/success';
const POST_CHECKOUT_SUCCESS_PREVIEW = '/checkout/success/view';
const POST_CHECKOUT_FAILURE = '/checkout/failure';
const POST_CHECKOUT_FAILURE_DEFAULT = '/checkout/failure/default';
const CHECKOUT_GUEST_MANUAL_ORDER_FORM = '/checkout/order-form';
const POST_CHECKOUT_THANK_YOU = '/checkout/thank-you';

export { ACCOUNT_ORDERS as A, CATEGORY as C, FORGOT_PASSWORD as F, HOME as H, LOGIN as L, PRODUCT as P, REGISTER as R, SHOPPING_CART as S, TERMS_AND_CONDITIONS as T, RESET_PASSWORD as a, ACCOUNT_ORDER as b, ACCOUNT_WISHLIST as c, ACCOUNT_SETTINGS as d, ACCOUNT_ADDRESSES as e, SEARCH as f, SHIPPING_RETURNS as g, PRIVACY_POLICY as h, TERMS_OF_USE as i, CONTACT_US as j, CHECKOUT as k, POST_CHECKOUT_SUCCESS as l, POST_CHECKOUT_SUCCESS_PREVIEW as m, POST_CHECKOUT_FAILURE as n, POST_CHECKOUT_FAILURE_DEFAULT as o, CHECKOUT_GUEST_MANUAL_ORDER_FORM as p, POST_CHECKOUT_THANK_YOU as q };
//# sourceMappingURL=paths-ZKN3m62_.js.map
